import * as React from 'react';

import { DropzoneRef } from 'react-dropzone';

import { UploadBoxSVG } from '@components/svgs';
import { useFeature } from '@hooks/useFeature';

import { UploadActionButtons } from './UploadActionButtons';

export const UploadManagerZDS = ({ onBrowseFiles }: { onBrowseFiles: DropzoneRef['open'] }) => {
  const hasRepoFiles = useFeature('repo_files');

  return (
    <div className='flex h-full w-full'>
      <div className='my-6 flex flex-1 flex-col items-center justify-center rounded-lg border border-dashed border-indigo-600 bg-gray-50'>
        <UploadBoxSVG />

        {hasRepoFiles ? (
          <>
            <span className='mt-6 block pb-2 text-lg font-bold text-gray-700'>Drag &amp; drop, or upload files</span>
            <div className='max-w-3xl text-center text-gray-500'>
              We support MP4, M4V, MOV, MP3 and PDF files. Video files will be uploaded as Interviews and PDF files will
              be uploaded as Insights.
            </div>
          </>
        ) : (
          <>
            <span className='mt-6 block pb-2 text-lg font-bold text-gray-700'>Drag &amp; drop files here</span>
            <div className='text-gray-500'>We support MP4, M4V, MOV, and MP3 files of any size.</div>
          </>
        )}

        <div className='mt-6 flex space-x-6'>
          <UploadActionButtons onBrowseFiles={onBrowseFiles} />
        </div>
      </div>
    </div>
  );
};
